import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Ruler } from "lucide-react";
import { useStaticTranslation } from "@/lib/staticTranslations";

const RING_SIZES = [
  { circumference: 44, size: 4 }, { circumference: 45, size: 5 },
  { circumference: 46, size: 6 }, { circumference: 47, size: 7 },
  { circumference: 48, size: 8 }, { circumference: 49, size: 9 },
  { circumference: 50, size: 10 }, { circumference: 51, size: 11 },
  { circumference: 52, size: 12 }, { circumference: 53, size: 13 },
  { circumference: 54, size: 14 }, { circumference: 55, size: 15 },
  { circumference: 56, size: 16 }, { circumference: 57, size: 17 },
  { circumference: 58, size: 18 }, { circumference: 59, size: 19 },
  { circumference: 60, size: 20 }, { circumference: 61, size: 21 },
  { circumference: 62, size: 22 }, { circumference: 63, size: 23 },
  { circumference: 64, size: 24 }, { circumference: 65, size: 25 },
  { circumference: 66, size: 26 }, { circumference: 67, size: 27 },
  { circumference: 68, size: 28 }, { circumference: 69, size: 29 },
  { circumference: 70, size: 30 }, { circumference: 71, size: 31 },
];

interface RingSizeGuideDialogProps {
  children?: React.ReactNode;
}

export const RingSizeGuideDialog = ({ children }: RingSizeGuideDialogProps) => {
  const { t, isHebrew } = useStaticTranslation("ringSizeDialog");

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children || (
          <button className="flex items-center gap-2 text-sm text-primary hover:text-primary/80 transition-colors underline underline-offset-4">
            <Ruler className="h-4 w-4" />
            <span>{t("triggerLabel", "מדריך מידות טבעות")}</span>
          </button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-md max-h-[80vh] overflow-hidden" dir={isHebrew ? "rtl" : "ltr"}>
        <DialogHeader>
          <DialogTitle className="text-xl">{t("title", "מדריך מידות טבעות")}</DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto max-h-[60vh] pr-2">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className={isHebrew ? "text-right" : "text-left"}>{t("circumference", "היקף אצבע (מ\"מ)")}</TableHead>
                <TableHead className={isHebrew ? "text-right" : "text-left"}>{t("size", "מידה")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {RING_SIZES.map((row) => (
                <TableRow key={row.size}>
                  <TableCell className={isHebrew ? "text-right" : "text-left"}>{row.circumference}</TableCell>
                  <TableCell className={`font-medium ${isHebrew ? "text-right" : "text-left"}`}>{row.size}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

// Helper function to check if a product has the ring size guide tag
export const hasRingSizeGuideTag = (tags?: string[]): boolean => {
  if (!tags) return false;
  return tags.some(tag => tag.includes('__tab1:מדריך-מידת-טבעות'));
};
